import React from 'react';
import { withTranslation } from 'react-i18next';
import { GoalSummaryCell } from './GoalSummaryCell';
import { GoalDrawer } from './GoalDrawer';
import { ConversionsCell } from './ConversionsCell';
import { LEVEL_ORDER } from './goalFormatters';

const COL_COUNT = 8;

function groupGoalsByLevel(goals) {
    const map = { BU: [], BUCC: [], CAMPAIGN: [], ADGROUP: [] };
    (goals || []).forEach(g => {
        if (map[g.level]) map[g.level].push(g);
    });
    LEVEL_ORDER.forEach(lvl => {
        map[lvl].sort((a, b) => (a.priority || 0) - (b.priority || 0));
    });
    return map;
}

function computeBreakdown(goals) {
    const counts = { ok: 0, warn: 0, critic: 0, unknown: 0 };
    (goals || []).forEach(g => {
        if (g.alert_level === 'good' || g.alert_level === 'success' || g.alert_level === 'normal') counts.ok++;
        else if (g.alert_level === 'bad') counts.warn++;
        else if (g.alert_level === 'critic') counts.critic++;
        else counts.unknown++;
    });
    return counts;
}

function BudgetHistoryRowComponent({ budget, formattedPeriod, isExpanded, onToggle, t }) {
    const goals = budget.goals || [];
    const totalGoals = goals.length;
    const goalsByLevel = groupGoalsByLevel(goals);
    const breakdown = computeBreakdown(goals);
    const isClickable = totalGoals > 0;

    const handleToggle = () => {
        if (isClickable) onToggle(budget.id);
    };

    const rowClass = [
        'budget-row',
        isExpanded ? '-expanded' : '',
        budget.is_current_period ? '-current' : '',
        isClickable ? '-clickable' : '',
    ].filter(Boolean).join(' ');

    return (
        <>
            <tr
                className={rowClass}
                onClick={handleToggle}
                role={isClickable ? 'button' : undefined}
                tabIndex={isClickable ? 0 : undefined}
                onKeyDown={(e) => {
                    if (isClickable && (e.key === 'Enter' || e.key === ' ')) {
                        e.preventDefault();
                        handleToggle();
                    }
                }}
            >
                <td>
                    {formattedPeriod}
                    {budget.is_current_period && (
                        <span className="badge-current-period">{t('business_unit_budget_history.current_period')}</span>
                    )}
                </td>
                <td>
                    {budget.allocated_amount}
                    {budget.budget_currency && (
                        <span className="budget-row__currency"> {budget.budget_currency}</span>
                    )}
                </td>
                <td>{budget.leftover}</td>
                <td>{budget.total_budget}</td>
                <td>
                    {budget.cost}
                    {budget.is_current_period && (
                        <span className="badge-in-progress" title={t('business_unit_budget_history.in_progress_hint')}>
                            {t('business_unit_budget_history.in_progress')}
                        </span>
                    )}
                </td>
                <td>
                    {budget.balance}
                    <div className={`item -${budget.balance_level}`}>{budget.balance_percentage}</div>
                </td>
                <td><ConversionsCell conversions={budget.conversions_in_period}/></td>
                <td>
                    <GoalSummaryCell
                        goals={goals}
                        breakdown={breakdown}
                        isExpanded={isExpanded}
                        isClickable={isClickable}
                    />
                </td>
            </tr>
            {isExpanded && isClickable && (
                <tr className="budget-row__drawer-row">
                    <td colSpan={COL_COUNT}>
                        <GoalDrawer goalsByLevel={goalsByLevel} />
                    </td>
                </tr>
            )}
        </>
    );
}

export const BudgetHistoryRow = withTranslation()(BudgetHistoryRowComponent);
